import { assetsUrl, mkIcon } from './mkIcon'

export const mkServiceIconOld = (textContent: string | number) =>
	mkIcon({ textContent: textContent.toString(), fillColor: 'FF0000', textColor: 'FFFFFF' })

export const mkServiceIcon = () => `${assetsUrl}red-map-pin.png`
